import { formatDate } from '@strata/helper-functions';

import { ClaimBasedAuthIdPrefix, RouteCodes } from 'services/constants';
import { type ReferralDetails } from 'store/api/treatmentApi';

/** Pending referrals can't be declined if routeCode matches a no decline route */
export const canDeclinePendingReferral = (routeCode?: string) =>
    !!routeCode &&
    !(
        [
            RouteCodes.CONTRACT,
            RouteCodes.MEM_PREF,
            RouteCodes.ACCEPT,
            RouteCodes.RND_ROBIN,
        ] as string[]
    ).includes(routeCode);

export const formatAuths = (auths: ReferralDetails['auths'], includeId = false) => {
    const anyClaimBased = auths.some((auth) => auth.caseId.startsWith(ClaimBasedAuthIdPrefix));
    if (anyClaimBased) {
        return ['Prior authorization is not required for this referral.'];
    }
    return auths.map(
        (auth) =>
            `${formatDate(auth.authStart)} - ${formatDate(auth.authExpiration)}${
                includeId ? ` (${auth.caseId})` : ''
            }`,
    );
};
